<template>
    <div class="product-recommendation-main">
        <div class="title">Travel Recommendation</div>
          <div class="content">
              <div class="item" 
                v-for="(item,index) in visibleItems" 
                :ref="'visibleItems' + index"
                :key="item.id" @click="productRecommendationEvent(item.id)" 
                :class="{'animate':isVisible[index] && index <= 3 && index >= 0,'banner-fade-in':item.fadeIn}"
              >
                  <img :class="{'banner-fade-in':isVisible[index]}" loading="lazy" :src="item.img" alt="">
                  <div class="lable">{{item.lable}}</div>
                  <div class="info">
                    <div class="group">{{item.group}}</div>
                      <div class="info-title">{{item.title}}</div>
                      <div class="desc">{{item.desc}}</div>
                      <div class="info-bottom">
                          <div class="info-btn">view Details</div>
                          <div class="time">Number Of Days Of Travel:{{item.time}} days</div>
                      </div>
                  </div>
              </div>
          </div>
        <div class="btn">
          <div class="btn-content" @click="showMoreEvent">
                <!-- <img loading="lazy"  src="../../../../static/img/product/Line.png" alt=""> -->
                <div class="btn-info">
                    Show more
                </div>
          </div>
        </div>
    </div>
</template>

<script>
// import productRecommendationList from '../../../../js/productContent/productRecommendation/productRecommendation.js'
import travelInfo from '/js/travel/travel.js'
export default {
    data(){
        return {
            productRecommendationList:[],
            visibleItems: [],  // 初始化为空数组
            isVisible:[]
        }
    },
    watch:{
      visibleItems:{
          handler(newVal,oldVal){
              if(newVal.length ==  oldVal.length){
                this.$message({
                  showClose: true,
                  message: 'No more data available at the moment !'
                });
              }
        }
      }
    },
    mounted(){
      this.productRecommendationList = travelInfo.travelList
      this.visibleItems = this.productRecommendationList.slice(0, 4);
      this.$nextTick(() => {
         this.visibleItems.forEach((_, index) => {
            const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                // 设置当前元素为可见
                this.$set(this.isVisible, index, true);
                observer.unobserve(entry.target); // 停止观察该元素
                }
            });
            }, { threshold: 0.01 });
            // 获取当前索引的元素并开始观察
            const element = this.$refs['visibleItems' + index][0];
            observer.observe(element);
        });
      })
    },
    methods:{
      showMoreEvent(){
        if(this.visibleItems.length > 9){
          this.visibleItems = this.visibleItems.map(item => ({
            ...item,
            fadeIn: false
          }));
        }
        let nextItems = this.productRecommendationList.slice(this.visibleItems.length, this.visibleItems.length + 3);
        nextItems = nextItems.map(item => ({
            ...item,
            fadeIn: true
        }));
        this.visibleItems = this.visibleItems.concat(nextItems);
      },
      productRecommendationEvent(id){
        this.$router.push({
            path:'/productDetails',
            query:{id:`${id}`}
          })
        // else if(id == 3){
        //   this.$router.push({
        //     path:'/productDetails',
        //     query:{id:5}
        //   })
        // }else if(id == 4 || id == 5){
        //   this.$router.push({
        //     path:'/productDetails',
        //     query:{id:9}
        //   })
        // }else if(id == 6){
        //   this.$router.push({
        //     path:'/productDetails',
        //     query:{id:10}
        //   })
        // }else if(id == 7){
        //   this.$router.push({
        //     path:'/productDetails',
        //     query:{id:6}
        //   })
        //   }else if(id == 8){
        //     this.$router.push({
        //       path:'/productDetails',
        //       query:{id:7}
        //     })
        // }else if(id == 9){
        //   this.$router.push({
        //     path:'/productDetails',
        //     query:{id:8}
        //   })
        // }
    },
  }
}
</script>
<style lang="scss" scoped>
@import '/style/pc/productContent/productRecommendation/productRecommendation.scss';
@import '/style/phone/productContent/ProductRecommendation/ProductRecommendation.scss';
@import '/style/pc/common/fadeIn.scss';
@import '/style/pc/common/animate.scss';
</style>